<template>
  <div id="app">
    <h1 class="main-heading-2">Tore Sind siin näha!</h1>

    <h2 v-if="count == 1">Oled esimene, kes postiindeksilt {{postalCode}} end huviliseks märkis!</h2>
    
    <h2 v-else-if="count > 1">{{postalCode}} postiindeksil on lisaks sinule veel {{count-1}} kogukonnaenergeetika huvilist</h2>
    
    <p class="clp2-paragraph-block">Otsime kõige rohemeelsemaid ja aktiivsemaid piirkondi Eestis, et neil aidata kogukonnaenergeetikaga alustada.</p>
    
    <p>Alustamiseks tuleb meil leida veel vähemalt {{remaining}} inimest Sinu naabruskonnast.</p>

    <div class="cta">
      <h2 class="subheading-2">Kutsu naabrid ja sõbrad meiega liituma, jagades järgmist linki:</h2>
      <h3><a class="share-link" :href=shareLink>www.rexplorer.ee</a></h3>
      
<!--
      <ul class="share-buttons" data-source="simplesharingbuttons.com">
        <li><a href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.rexplorer.ee%2F&quote=" 
              title="Share on Facebook" 
              target="_blank" 
              onclick="window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(document.URL) + '&quote=' + encodeURIComponent(document.URL)); return false;">
            <img alt="Share on Facebook" src="https://uploads-ssl.webflow.com/5fc500d96cbed62994f4433a/616fd8c01d11cff7998f3b74_Facebook.png" /></a>
        </li>
        <li><a href="mailto:?subject=&body=:%20https%3A%2F%2Fwww.rexplorer.ee%2F" target="_blank" title="Send email" onclick="window.open('mailto:?subject=' + encodeURIComponent(document.title) + '&body=' +  encodeURIComponent(document.URL)); return false;">
            <img alt="Send email" src="https://uploads-ssl.webflow.com/5fc500d96cbed62994f4433a/616fd8bfd36726e2b4150056_Email.png" /></a></li>
      </ul>
-->
      
    </div>
  </div>
</template>

<script>
const axios = require('axios');
const queryString = require('query-string');
const minCommunity = 10; 

export default {
  name: 'App',
  components: {
  }, 
  data(){
    return {
      count: 0,
      postalCode: '',
      email: '',
      cioId: '',
      minCommunity: minCommunity,
    }
  },
  computed: {
    remaining() {
      return minCommunity - this.count;
    },
    shareLink() {
      let link = 'http://rexplorer.ee/?utm_source=community_landing&utm_medium=referral&utm_campaign=community_ea';
      if (this.cioId)
        link += `&utm_content=${this.cioId}`;
      return link;
    },
  },
  mounted: function() {
    const parsed = queryString.parse(location.search);
    this.email = parsed.email;
    this.postalCode = parsed.postalCode;
    var vm = this;

    axios.get('https://kdk4isiri1.execute-api.eu-central-1.amazonaws.com/prod/community', {
      params: {
        email: vm.email,
        postalCode: vm.postalCode
      }
    })
    .then(function (response) {
      vm.count = response.data.count;
      vm.cioId = response.data.cioId;
    })
    .catch(function (error) {
      console.log(error);
    })
    .then(function () {
      // always executed
    });  
  },
}
</script>

<style>
ul.share-buttons{
  list-style: none;
  padding: 0;
}

ul.share-buttons li{
  display: inline;
}

ul.share-buttons .sr-only{
  position: absolute;
  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);
  padding: 0;
  border: 0;
  height: 1px;
  width: 1px;
  overflow: hidden;
}
</style>